import { config } from './defaultTheme.js';
var defaultBlueName = 'themeBlue';
export var loadTheme = function loadTheme(theme, json) {
  if (theme === void 0) {
    theme = defaultBlueName;
  }

  if (json === void 0) {
    json = config;
  }

  // 兼容下标选择主题
  if (Number.isInteger(theme)) {
    var _keys = Object.keys(json);

    theme = _keys.length > theme && theme >= 0 ? _keys[theme] : defaultBlueName;
  }

  var themeVars = json[theme] ? json[theme] : json[defaultBlueName];
  var keys = Object.keys(themeVars);
  keys.forEach(function (key) {
    if (Object.hasOwnProperty.call(themeVars, key)) {
      var value = themeVars[key];
      document.body.style.setProperty(key, value);
    }
  });
};
export var defaultTheme = config;
export default {
  defaultTheme: defaultTheme,
  loadTheme: loadTheme
};